import { render, staticRenderFns } from "./chanyeyanjiu.vue?vue&type=template&id=43a20410&"
import script from "./chanyeyanjiu.vue?vue&type=script&lang=js&"
export * from "./chanyeyanjiu.vue?vue&type=script&lang=js&"
import style0 from "./chanyeyanjiu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports